import type {SharedMarkdownContentProps} from '@github-ui/code-view-shared/components/SharedMarkdownContent'
import {SharedMarkdownContent} from '@github-ui/code-view-shared/components/SharedMarkdownContent'
import {useRef} from 'react'

import SelectAllShortcut from '../utilities/SelectAllShortcut'

export function MarkdownContent(props: SharedMarkdownContentProps) {
  const markdownContainer = useRef<HTMLDivElement>(null)
  return (
    <>
      <SharedMarkdownContent {...props} ref={markdownContainer} />
      <SelectAllShortcut containerRef={markdownContainer} />
    </>
  )
}
